import { renderStatusCell } from 'ui/table/StatusCell';

export const renderOrderStatusCell = renderStatusCell({ Closed: 'green' }, 'yellow');
